module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper willmustlist pt-header65"
  }, [_c('header', {
    staticClass: "gheader -white gheader-fix"
  }, [_c('div', {
    staticClass: "gheader__link-back"
  }, [_c('a', {
    on: {
      "click": _vm.goTop
    }
  }, [_vm._v("戻る")])])]), _vm._m(0), _c('section', {
    staticClass: "content"
  }, [_c('dl', {
    staticClass: "container"
  }, [_c('dt', [_vm._v("教育マニュアル")]), _c('dd', {
    staticClass: "divider"
  }, _vm._l((_vm.ruleList), function(path, rule) {
    return _c('button', {
      staticClass: "btn02 -home-style secret",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.goToRule(path)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(rule))])])
  }), 0), _c('dt', [_vm._v("研修動画")]), _c('dd', {
    staticClass: "divider"
  }, _vm._l((_vm.ruleList2), function(path, rule) {
    return _c('button', {
      staticClass: "btn02 -home-style secret",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.goToRule(path)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(rule))])])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('img', {
    staticClass: "page__hero__img",
    attrs: {
      "src": require("../images/page__hero__img/video_categories.png"),
      "alt": "雰囲気のいい職場｜社員研修"
    }
  }), _c('h1', {
    staticClass: "page__title"
  }, [_vm._v("社外秘！教育マニュアル・研修動画")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3cb99dea!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/video-categories.pug
// module id = 1392
// module chunks = 1